/* eslint-disable no-unneeded-ternary */
/* eslint-disable */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Button } from '@mui/material';
import Toggle from 'rsuite/Toggle';
import excel from 'src/Images/excel.svg';
import styles from './MyUsersPage.module.scss';
// import ListTable from '../../../../Components/ListTable/ListTable';
import { BackdropLoader } from '../../../Components/Loaders';
import ListTable from '../../../Components/ListTable/ListTable';
import ImageModal from '../../../Components/Modals/ImageModal/ImageModal';
import { modalActions } from '../../../Actions';
import { notificationServices } from '../../../Services';
import userRolesAndPermissions from '../../../Services/userRolesAndPermissions.services';
import { handleResponseStreamDownload } from '@/Helpers';
import authActions from '@/Actions/auth.actions';
import { useAuth } from '@/Components/Auth/Login/auth';
import GlobalSearch from '@/Components/globalSearch/search';
import { ca } from 'date-fns/locale';
import { AlertModal } from '@/Components/Modals';

const TABLE_COLUMNS = [
	{
		title: 'ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Username',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Display Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'User Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'User Level',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'App Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Email',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Edit User',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Active',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Delete User',
		config: {
			type: 'DATA',
		},
	}
];

const COLMAP = {
	ID: 'id',
	Username: 'username',
	'Display Name': 'displayName',
	'User Type': 'userFor',
	'User Level': 'levelName',
	'App Store': 'storeName',
	Email: 'email',
};

function MyUsersPermissionsPage({ createPath, toggleAlert }) {
	const history = useHistory();
	const [isloading, setIsloading] = useState(false);
	const [usersData, setUsersData] = useState([]);
	const [selectedStore, setSelectedStore] = useState(null);
	const [search, setSearch] = useState('');
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const { userRolesDict = {} } = userConfig || {};
	const isInternal = Object?.values(userRolesDict)?.includes('INTERNAL') || Object?.values(userRolesDict)?.includes('Internal');


	const handleListFetch = async () => {
		setIsloading(true);
		try {
			const response = await userRolesAndPermissions.getUsersList();
			if (response?.statusCode === 200) {
				setSelectedStore(selectedStore);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				setUsersData(response?.data);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message:
					'Unable to fetch users list, please connect with UY Team',
			});
		} finally {
			setIsloading(false);
		}
	};

	useEffect(() => {
		handleListFetch();
	}, []);

	const handleAddClick = () => {
		history.push(createPath);
	};

	const handleClick = (userId) => {
		history.push(`${createPath}?isEdit=true&id=${userId}`);
	};

	const handleIsActive = async (id, isActive) => {
		setIsloading(true);
		try {
			const response =
				await userRolesAndPermissions.changeUserActiveStatus({
					data: {
						userId: id,
						status: isActive,
					},
				});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				handleListFetch();
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
		} finally {
			setIsloading(false);
		}
	};

	const handleDelete = async (id) => {
		try {
			setIsloading(true);
			const response = await userRolesAndPermissions.changeUserActiveStatus({
					data: {
						userId: id,
						isDeleted: true,
					},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				toggleAlert(false);
				handleListFetch();
			}
		} catch (error) {
			console.error(error);
		}finally{
			setIsloading(false);
		}
	};

	const handleConfirmDelete = useCallback((user) => {
		toggleAlert(true, {
			heading: 'Delete User',
			message: `Are you sure you want to delete this user ${user?.username}?`,
			handleConfirm: () => {
				handleDelete(user?.id);
			},
		});
	},[]);

	const SPECIAL_ITEMS = {
		'Edit User': (id) => {
			const user = usersData?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className={styles.btn_container}>
					<Button
						fullWidth
						variant='outlined'
						color='primary'
						onClick={() => {
							handleClick(user?.id);
						}}
					>
						EDIT
					</Button>
				</div>
			);
		},
		'Delete User': (id) => {
			const user = usersData?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div key={id} className={styles.btn_container}>
					<Button variant='outlined' color='error' onClick={() => {
						handleConfirmDelete(user);
					}}
					>
						DELETE
					</Button>
				</div>
			);
		},
		Active: (id) => {
			const user = usersData?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div key={id} className={styles.btn_container}>
					<Toggle
						checked={user?.isActive}
						size='md'
						onChange={() => {
							handleIsActive(id, !user?.isActive);
						}}
					/>
				</div>
			);
		},
	};

	const generateData = () => {
		if (!search) return usersData;
		return usersData.filter((item) =>
			item?.username?.toLowerCase().includes(search.toLowerCase()) ||
			item?.displayName?.toLowerCase().includes(search.toLowerCase()) ||
			item?.email?.toLowerCase().includes(search.toLowerCase()) ||
			item?.storeName?.toLowerCase().includes(search.toLowerCase()) ||
			item?.id?.toString().includes(search) ||
			item?.userFor?.toString().toLowerCase().includes(search.toLowerCase()) ||
			item?.levelName?.toString().toLowerCase().includes(search.toLowerCase())
		);
	};

	const handleExport = async (data) => {
		try {
			setIsloading(true);
			const res = await userRolesAndPermissions.getUserExport({
				req: {
					data,
				},
			});
			handleResponseStreamDownload(res, 'Users List.csv');
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error.message || 'Unknown error occurred',
			});
		} finally {
			setIsloading(false);
		}
	};

	return (
		<div className={styles.root}>
			{/* <ListModal handleConfirm={iAmClicked} singleSelectable /> */}
			<BackdropLoader showProgress isLoading={isloading} />
			<ImageModal />
			<AlertModal />
			<div className='flex justify-between m-4 '>
				<span className='font-bold text-[16px]'>My Users</span>
				{level > 2 && isInternal && (
					<Button
						onClick={handleAddClick}
						className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
					>
						+ Add User
					</Button>
				)}
			</div>
			<div className='flex justify-between items-center gap-4'>
				<GlobalSearch
					searchDropDown={false}
					placeholderText='Search ...'
					setSearchValue={setSearch}

				/>
				<div
					onClick={() => handleExport(usersData)}
					className='w-[8.5rem] h-[2.5rem] text-center cursor-pointer flex items-center justify-center gap-[0.5rem] z-10 bg-green-700 rounded-md hover:bg-green-800 transition-colors'
				>
					<img src={excel} alt='excel' className='w-6' />
					<span className='text-white text-[13px] font-medium'>EXPORT</span>
				</div>
			</div>

			<ListTable
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={generateData()}
				actions={level > 2 && isInternal ? [...SPECIAL_COLUMNS] : []}
				special={SPECIAL_ITEMS}
				showBtnContainer={false}
				allowExport={false}
			/>
		</div>
	);
}
const mapStateToProps = (state) => {
	const { navState, userPermissions } = state.navigation;
	return {
		userPermissions,
		navState,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleListModal,
	toggleAlert: modalActions.toggleAlert,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MyUsersPermissionsPage);
